import { render } from "./OnlineBookingInvoice.vue?vue&type=template&id=b1223708&scoped=true"
import script from "./OnlineBookingInvoice.vue?vue&type=script&lang=js"
export * from "./OnlineBookingInvoice.vue?vue&type=script&lang=js"

import "./OnlineBookingInvoice.vue?vue&type=style&index=0&id=b1223708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1223708"]])

export default __exports__